import React from 'react'
import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { IcomoonIcon } from '../IcomoonIcon'

export type OrderType = 'asc' | 'desc' | null

type Props = {
  type?: OrderType
  onClick: () => void
}

export const ToggleSortIcon: React.FC<Props> = (props) => {
  const iconName =
    props.type === 'asc'
      ? 'arrow8-up'
      : props.type === 'desc'
        ? 'arrow8-down'
        : 'sort-fill'

  const color = props.type === null ? colors.gray70 : '#1f9db8'

  return (
    <div
      onClick={props.onClick}
      css={css`
        font-size: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 5px;
        height: 22px;
        width: 22px;

        :hover {
          background-color: ${colors.gray50};
          border-radius: 50%;
          cursor: pointer;
        }
      `}
    >
      <IcomoonIcon
        name={iconName}
        css={css`
          color: ${color};
          margin-top: ${props.type === 'desc' ? '3px' : 0};
          margin-bottom: ${props.type === 'asc' ? '3px' : 0};
        `}
      />
    </div>
  )
}
